import React from "react";
import { useGlobalValue } from "../../../state/GlobalProvider";
import { SovosLink, SovosTypography } from "mosaic-react";
import { createLink } from "../../../utils";
import AuditStatus from "../AuditStatus/AuditStatus";
const CellCard = props => {
  const {
    params,
    proxy,
    customCardsCells
  } = useGlobalValue();

  // TODO: use prop filter to highlight corresponding
  const {
    value: cell,
    type
  } = props;
  let valueElement;
  switch (type) {
    case "customComponent":
      {
        const {
          customComponent
        } = cell || {};
        const CustomComponent = customCardsCells && customCardsCells[customComponent] ? customCardsCells[customComponent] : null;
        return CustomComponent && /*#__PURE__*/React.createElement(CustomComponent, props);
      }
    case "status":
      valueElement = /*#__PURE__*/React.createElement(AuditStatus, {
        value: cell
      });
      break;
    case "object":
      {
        if (cell && cell.id && (cell.name === 0 || !!cell.name) && cell.customParam) {
          valueElement = /*#__PURE__*/React.createElement(SovosLink, {
            href: createLink(undefined, proxy, cell, {
              ...params,
              ...cell.customParam
            })
          }, cell.name);
        } else if (cell && cell.id && cell.name) {
          valueElement = /*#__PURE__*/React.createElement(SovosLink, {
            href: createLink(undefined, proxy, cell, params),
            label: cell.name
          }, cell.name);
        } else {
          valueElement = null;
        }
        break;
      }
    default:
      valueElement = /*#__PURE__*/React.createElement(SovosTypography, {
        sx: {
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        variant: "body2"
      }, typeof cell === "object" ? "" : cell);
  }
  return valueElement;
};
export default CellCard;